import Input from "./input";
import DaumPostcodeEmbed from "react-daum-postcode";
import { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/closeIcon.svg";

interface SearchAddressProps {
    onAddressChange: (zoneCode: string, address: string, detailAddress: string) => void;
    post: string;
    customerAddress: string;
    customerAddressDetail: string;
    status?: string;
}

const NewOrderSearchAddress = ({ onAddressChange, post, customerAddress, customerAddressDetail, status }: SearchAddressProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [address, setAddress] = useState(post);
    const [zoneCode, setZoneCode] = useState(customerAddress);
    const [detailAddress, setDetailAddress] = useState(customerAddressDetail);
    const [errorStatus, setErrorStatus] = useState("");

    const handleComplete = (data: any) => {
        const roadAddress = data.roadAddress;
        const jibunAddress = data.jibunAddress;
        const zonecode = data.zonecode;

        setTimeout(() => {
            const buildingName = data.buildingName?.trim();
            const completeAddress = buildingName ? `${roadAddress} (${buildingName})` : roadAddress;

            setAddress(completeAddress);
            setZoneCode(zonecode);
            setErrorStatus("");
            setIsOpen(false);

            onAddressChange(zonecode, completeAddress, detailAddress);
        }, 100);
    };

    const handleDetailAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setDetailAddress(value);
        setErrorStatus("");

        onAddressChange(zoneCode, address, value);
    };

    const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setAddress(value);
        setErrorStatus("");

        onAddressChange(zoneCode, value, detailAddress);
    };

    useEffect(() => {
        setZoneCode(post);
        setAddress(customerAddress);
        setDetailAddress(customerAddressDetail);
    }, [post, customerAddress, customerAddressDetail]);

    useEffect(() => {
        setErrorStatus(status || "");
    }, [status]);

    return (
        <div className="flex flex-col w-full p-2 gap-1 relative">
            <div className="" onClick={() => setIsOpen(true)}>
                <Input
                    status={errorStatus}
                    className="w-full"
                    iconPosition="right"
                    icon={
                        status !== "view" && (
                            <button onClick={() => setIsOpen(true)} className="text-sm text-primary2 font-bold whitespace-nowrap">
                                검색
                            </button>
                        )
                    }
                    placeholder="우편번호 검색"
                    value={zoneCode}
                    readOnly
                />
            </div>

            <div className="flex flex-col gap-1">
                {/* <div onClick={() => setIsOpen(true)}>
                    <Input status={errorStatus} className=" w-full" value={address} placeholder="주소 검색" readOnly />
                </div> */}
                <div>
                    <Input
                        status={errorStatus}
                        className=" w-full"
                        value={address}
                        onChange={handleAddressChange}
                        placeholder="주소 검색"
                    />
                </div>

                <Input
                    status={errorStatus}
                    className="w-full"
                    placeholder="상세주소 직접입력"
                    value={detailAddress}
                    onChange={handleDetailAddressChange}
                />
            </div>
            {isOpen && (
                <div
                    className="absolute z-[100] mt-[34px] bg-white border rounded-lg shadow-lg overflow-hidden"
                    style={{ width: "calc(100% - 15px)" }}
                >
                    <div className="px-6 py-5 text-2xl font-bold border-b border-gray3 flex items-center justify-between">
                        <p>우편번호 찾기</p>
                        <CloseIcon onClick={() => setIsOpen(false)} className="cursor-pointer" />
                    </div>
                    <DaumPostcodeEmbed className="min-h-[470px]" onComplete={handleComplete} />
                </div>
            )}
        </div>
    );
};

export default NewOrderSearchAddress;
